import React, { useState } from "react";
import { Container, Grid } from "@material-ui/core";
import Page from "../../components/Page";
import CreateUserView from "./CreateUserView";
import UserTable from "./UserTable";
import {HasRole} from "../../common/Util";
import {RoleIdEnum} from "../../generated/graphql";

export default () => {
    return (
        <Page title={"user page"}>
            <Container maxWidth={false} style={{ padding: "30px"}}>
                <HasRole roles={[RoleIdEnum.Admin]}>
                    <Grid container spacing={2}>
                        <CreateUserView/>
                        <UserTable/>
                    </Grid>
                </HasRole>
            </Container>
        </Page>
    )
}